import { render, staticRenderFns } from "./OcrPopup.vue?vue&type=template&id=41a457b1&scoped=true"
import script from "./OcrPopup.vue?vue&type=script&lang=js"
export * from "./OcrPopup.vue?vue&type=script&lang=js"
import style0 from "./OcrPopup.vue?vue&type=style&index=0&id=41a457b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a457b1",
  null
  
)

export default component.exports